import React from "react";
import ReactDOM from "react-dom/client";
import "./index.module.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// 确保使用正确的 antd 版本对应的样式
// 对于 antd v5:
import "antd/dist/reset.css";
import { sendMessageToParent } from "./utils";
// 对于 antd v4:
// import "antd/dist/antd.min.css";

const eleRoot = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(eleRoot);
root.render(<App />);

// 监听内容变化
const resizeObserver = new ResizeObserver((entries) => {
  entries.forEach((entry) => {
    const { height } = entry.contentRect; // 获取宽高
    console.log(`元素的新高度: ${height}`);
    sendMessageToParent({
      type: "member-height",
      height,
    });
  });
});

if (eleRoot) {
  resizeObserver.observe(eleRoot);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
